import { render, staticRenderFns } from "./RevolvingPutOptionPremiumPaymentsStatusRenderer.vue?vue&type=template&id=20c38937&"
import script from "./RevolvingPutOptionPremiumPaymentsStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./RevolvingPutOptionPremiumPaymentsStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports